import { Table } from '@components/primitives/Chart/Table'
import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle'
import type { DrugContraindication } from '@modules/drugs/helpers/getTreatmentPageData'
import type { ReactNode } from 'react'

export default function TreatmentContraindicationsProperties({
  drugContraindications,
  drugName,
}: {
  drugContraindications: DrugContraindication[]
  drugName: string
}) {
  if (drugContraindications.length === 0) {
    return null
  }
  return (
    <>
      <Text
        className='my-4 text-neutral500'
        styleName={'p'}
        value={`${drugName} Contraindications`}
      />
      <Table
        borderClass='border-neutral100'
        headerBackground='bg-neutral50'
        headerRow={['Condition', 'Risk Level', 'Notes']}
        rows={[
          ...drugContraindications.map((item) => [
            item.conditionName,
            TreatmentContradictionRiskLevel(item.riskLevel),
            item.notes,
          ]),
        ]}
        textAlignment='text-left'
        textColor='text-neutral500'
      />
    </>
  )
}

function TreatmentContradictionRiskLevel(riskLevel: string): ReactNode {
  const hasAlert = riskLevel === 'Do Not Combine'
  return (
    <span className={classMerge(hasAlert && 'font-bold')}>
      {riskLevel}{' '}
      {hasAlert && (
        <Icon className='mx-2 text-neutral500' icon={faExclamationTriangle} />
      )}
    </span>
  )
}
